import { render, staticRenderFns } from "./ModalAddNotes.vue?vue&type=template&id=210aaf50&"
import script from "./ModalAddNotes.vue?vue&type=script&lang=js&"
export * from "./ModalAddNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports